import "core-js/modules/es6.object.assign.js";

var defaultState = function defaultState() {
  return {
    isAuth: true,
    user: {
      isAdmin: true,
      name: 'Name LastName',
      shortName: 'ShortName',
      avatar: 'https://www.fillmurray.com/640/360'
    }
  };
};

var state = defaultState();
var getters = {
  user: function user(state) {
    return state.user;
  },
  isAuth: function isAuth(state) {
    return state.isAuth;
  }
};
var mutations = {
  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },
  logout: function logout(state) {
    state.isAuth = false;
  }
};
var actions = {
  logoutUser: function logoutUser(context, payload) {
    context.commit('logout', payload);
  }
};
export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true
};